// 深拷贝（JSON 方式，适用于纯数据节点/连接结构）
// useUndoHistory 和 useClipboard 共用，避免重复定义
export function deepClone<T>(v: T): T {
  return JSON.parse(JSON.stringify(v));
}
